import { render, staticRenderFns } from "./EventsWidget.vue?vue&type=template&id=8b2bb0e4&"
import script from "./EventsWidget.ts?vue&type=script&lang=typescript&"
export * from "./EventsWidget.ts?vue&type=script&lang=typescript&"
import style0 from "./EventsWidget.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VDataTable,VIcon})
